import React from 'react';
import { DateRangePicker } from 'react-dates';

export default (props) => {
  return (
    <div className="separated-datepicker">
      <DateRangePicker {...props}/>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/DatepickerSeparated.js